import { render } from "./AdminTicket.vue?vue&type=template&id=3957832f&scoped=true"
import script from "./AdminTicket.vue?vue&type=script&lang=js"
export * from "./AdminTicket.vue?vue&type=script&lang=js"

import "./AdminTicket.vue?vue&type=style&index=0&id=3957832f&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3957832f"]])

export default __exports__